import React, { useEffect, useState } from 'react';
import Select from 'react-select';

// modal
import Modal from "../Modal";

// style
import RightSidebarStyle from './style'

// img
import Close from '../../Assets/Close.svg'
import SvgIcon from '../../Assets/svg-icon.svg'
import PdfIcon from '../../Assets/pdf-icon.svg'

// -- redux
import {connect} from "react-redux";
import {AddContact,EditContact,DeleteContact} from "../../Redux/Actions/ContactUsAction"
import { icon } from '@fortawesome/fontawesome-svg-core';

function RightSidebar(props) {
    const [response, setResponse] = useState(false);
    const [Title, setTitle] = useState('');
    const [Type, setType] = useState('');
    const [TypeID, setTypeID] = useState('');
    const [key, setKey] = useState('');
    const [keyError, setKeyError] = useState('');
    const [base64String, setBase64String] = useState('');
    const [ImgName, setImgName] = useState('');
    const [SVGError, setSVGError] = useState('');
    const [PDFError, setPDFError] = useState('');
    const [OpenModal, setModal] = useState(false);


    const TypeOptions = [
        { value: 'Mobile', label: 'Mobile', id: '6' },
        { value: 'Email', label: 'Email', id: '7' },
        { value: 'Message', label: 'Message', id: '8' },
        { value: 'WebView', label: 'WebView', id: '4' },
    ];

    useEffect(()=>{
        document.getElementById('SidebarForm').scrollTo(0, 0);
        if (props.item_data) {
            setTitle(props.item_data.title);
            setBase64String(props.item_data.icon);
            setTypeID(props.item_data.type && props.item_data.type.toString());
            setKey(props.item_data.information && props.item_data.information);
        }
    },[props]);

    useEffect(() => {
        setTimeout(function () {
            setResponse(true)
        }, 1000)
    }, []);


    const colourStyles = {
        control: (styles, state) => (
            {
                ...styles,
                backgroundColor: '#3C3C3C',
                border: state.isFocused ? '1px solid #A0A0A0' : '1px solid #3C3C3C',
                transition: 'all 0.25s linear 0s',
                "&:hover": {
                    border: '1px solid #A0A0A0'
                },
                padding: '4px 6px',
                boxShadow: state.isFocused ? null : null,
            }),
            singleValue: (baseStyles, state) => ({
                ...baseStyles,
                color:state.isFocused ? '#ffffff' : '#ffffff',
                backgroundColor: '#3C3C3C'
            }),
    };

    const convertSvgToBase64 = (file) => {
        const reader = new FileReader();

        reader.onload = (e) => {
        const base64String = e.target.result; // This is the data URL (e.g., data:image/svg+xml;base64,...)
        // You can now use base64String, for example, store it in state
            console.log(base64String);
            setBase64String(base64String)
        };

        reader.onerror = (error) => {
        console.error("Error reading file:", error);
        };

        reader.readAsDataURL(file); // This initiates the reading process
    };

    const handleSvgPreview = (e, type) => {
        if(e.target.files[0].size  / 1024 < 2000){
            if(e.target.files[0].type === 'image/svg+xml'){
                e.target.files[0] && setImgName(e.target.files[0].name);
                convertSvgToBase64(e.target.files[0]);
                setSVGError('')
            } else {
                setSVGError('Only svg is allowed')
            }
        } else{
            setSVGError('File size exceeds')
        }
    };

    const CloseSidebar = (e) => {
        e.preventDefault();
        document.getElementById('SidebarForm').scrollTo(0, 0);
        setTitle('');
        setType('');
        setKey('');
        setBase64String('');
        setImgName('');
        setKeyError('');
        setSVGError('');
        setPDFError('');
        props.close()
    };

    const handleModal = (e, type) => {
        e.preventDefault();
        if(TypeID === '4'){
            let expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
            let regex = new RegExp(expression);
            if (key.match(regex)) {
                setKeyError('');
                setModal(type);
            } else {
                setKeyError('Invalid URL');
            }
        } else if(TypeID === '7'){
            let expression =  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
            let regex = new RegExp(expression);
            if (key.match(regex)) {
                setKeyError('');
                setModal(type);
            } else {
                setKeyError('Invalid Email');
            }
        } else if(TypeID === '6' || TypeID === '8'){
            let expression = /^[0-9]+$|^$/;
            let regex = new RegExp(expression);
            if (key.match(regex)) {
                setKeyError('');
                setModal(type);
            } else {
                setKeyError('Only numbers are allowed');
            }
        } else{
            setModal(type);
        }
    };

    const CloseModal = (e, type) => {
        e.preventDefault();
        document.getElementById('SidebarForm').scrollTo(0, 0);
        if(type === 'update_yes'){
            const data = {
                id: props.item_data.id,
                title: Title,
                icon: base64String,
                type: TypeID,
                information: key
            };
            props.EditContact(data);
            setModal(false);
            setTitle('');
            setType('');
            setTypeID('');
            setKey('');
            setBase64String('');
            setImgName('');
            setKeyError('');
            setSVGError('');
            setPDFError('');
            props.close();
        } 
        else if(type === 'update_no'){
            setModal(false)
        }
        else if(type === 'add_yes'){
            const data = {
                //id: props.item_data.id,
                title: Title,
                icon: base64String,
                type: TypeID,
                information: key
            };
            props.AddContact(data);
            setModal(false);
            setTitle('');
            setType('');
            setTypeID('');
            setKey('');
            setBase64String('');
            setImgName('');
            setKeyError('');
            setSVGError('');
            setPDFError('');
            props.close();
        }
        else if(type === 'add_no'){
            setModal(false)
        }
        else if(type === 'delete_yes'){
            props.DeleteContact(props.item_data.id);
            setModal(false);
            props.close();
        } else if(type === 'delete_no'){
            setModal(false)
        }
    };

    const handleChange = (selected) => {
        setType(selected);
        setTypeID(selected.id);
        setKey('')
    };

    const handleKey = (e) => {
        if(TypeID === '6' || TypeID === '8'){
            let expression = /^[0-9]+$|^$/;
            let regex = new RegExp(expression);
            if (e.target.value.match(regex)) {
                setKeyError('');
                setKey(e.target.value)
            } else {
                setKeyError('Only numbers are allowed');
            }
        } else{
            setKey(e.target.value)
        }
    };

    useEffect(() => {
        props.edit_data && response && props.response({type: props.edit_data.status, message: props.edit_data.message});
    }, [props.edit_data]);

    useEffect(() => {
        props.delete_data && response && props.response({type: props.delete_data.status, message: props.delete_data.message});
    }, [props.delete_data]);

    return (
        <>
            {props && props.sidebar && <div onClick={(e) => CloseSidebar(e)} className='overlay'/>}
            <div className={props && props.sidebar ? 'dark-background right-sidebar-wrap' : 'dark-background right-sidebar-wrap right-sidebar-wrap-close'}>
                <div className='d-flex justify-content-between align-items-center'>
                    <h5 className='text-uppercase text-white'>{props.Type} CONTACT</h5>
                    <img onClick={(e) => CloseSidebar(e)} src={Close} alt='Close' className='cursor-pointer' />
                </div>
                <form className='sidebar-form-wrap' id='SidebarForm'>
                    <div className='mt-4'>
                        <label className='text-grey-6 f-16 d-block mb-1'>Title <span className='text-danger'>*</span></label>
                        <input
                            value={Title}
                            onChange={(e) => setTitle(e.target.value)}
                            type='text'
                            placeholder='Enter Title'
                            className="w-100 input-style"
                        />
                    </div>
                    <div className='mt-4'>
                        <label className='text-grey-6 f-16 d-block mb-1'>Icon<span className='text-danger'>*</span></label>
                        <div className='d-flex justify-content-between'>
                            <div className='text-center' title={ImgName}>
                                <label className="custom-file-upload position-relative d-flex align-items-center justify-content-center mb-0">
                                    <input type="file" accept="image/svg+xml" onClick={(e) => e.target.value = null} onChange={(e) => handleSvgPreview(e, 'svg')}/>
                                    <div className='w-100'>
                                        {base64String !== '' ? <img src={base64String} alt='svg-icon' style={{ width: '30%', height: '30%', objectFit: 'contain' }}/> : <span>Click to browse</span>}
                                        {base64String !== '' && <p className='text-white mb-0 mt-1 col-12 ml-auto mr-auto text-truncate'>{ImgName}</p>}
                                        {base64String !== '' &&
                                        <div onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setImgName('');
                                            setBase64String('');
                                        }}
                                             className='remove-button'
                                        >
                                            <p className='text-uppercase mb-0 text-white'>Remove</p>
                                        </div>
                                        }
                                    </div>
                                </label>
                                <span style={{color: '#A0A0A0'}} className='f-12'>Upload SVG for Android</span>
                                {SVGError && <span className='f-12 text-danger d-block'>{SVGError}</span>}
                            </div>
                        </div>
                    </div>
                    <div className='mt-4'>
                        <div className='mt-4'>
                            <label className='text-grey-6 f-16 d-block mb-1'>Type <span className='text-danger'>*</span></label>
                            <Select
                                value={TypeOptions.filter(function(option) {
                                    return option.id === TypeID;
                                }) || ''}
                                onChange={(e) => handleChange(e)}
                                options={TypeOptions}
                                styles={colourStyles}
                                placeholder= 'Choose Type'
                            />
                        </div>
                    </div>
                    <div className='mt-4'>
                        <label className='text-grey-6 f-16 d-block mb-1'>Key <span className='text-danger'>*</span></label>
                        <textarea
                            value={key}
                            onChange={(e) => {
                                handleKey(e)
                            }}
                            placeholder='Enter Information'
                            className="w-100 text-input-style"
                        />
                        <small className='text-white'>Max limit 500 characters</small>
                        {keyError && <p className='text-danger f-12'>{keyError}</p>}
                    </div>
                    <div className='mt-5 mb-5 text-center'>
                        {props.Type === 'Edit' &&
                            
                            <div className='d-flex align-items-center justify-content-center'>
                                <button
                                onClick={(e) => handleModal(e, 'delete')}
                                className="form-button form-button-ghost f-14 mr-2"
                            >
                                Delete
                            </button>
                                <button disabled={!(Title && base64String && TypeID && key)} onClick={(e) => handleModal(e, 'update')} className="form-button ml-2 f-14">
                                    Update
                                </button>
                            </div>
                        }
                        {props.Type === 'Add' &&
                            <div className='d-flex align-items-center justify-content-center'>
                                <button disabled={!(Title && base64String && TypeID && key)} onClick={(e) => handleModal(e, 'add')} className="form-button ml-2 f-14">
                                    Add
                                </button>
                            </div>
                        }
                    </div>
                </form>
            </div>
            {OpenModal && <Modal Name={Title} Type={OpenModal} Close={(e, type) => CloseModal(e, type)}/>}
            <RightSidebarStyle/>
        </>
    );
}

const mapStateToProps = ({ContactUsReducer}) => {
    const {loading, data, edit_data} = ContactUsReducer;
    return {loading, data, edit_data}
};

const mapDispatchToProps = {
    AddContact,
    EditContact,
    DeleteContact
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSidebar)